import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { MenuItem } from '../../models/menu-item';
import { PermissionService } from '../../resources/auth/permission.service';

@Injectable()
export class MenuService {
  private _menuItems: MenuItem[];
  public get menuItems(): MenuItem[] {
    return this._menuItems;
  }

  constructor(
    private permissionService: PermissionService,
  ) {
    this._menuItems = [];
  }

  addMenu(items: MenuItem[]) {
    Observable.concat(...items.map(item => Observable.of(item)))
    .flatMap(menuItem => {
      return this.permissionService.hasPermissions(...menuItem.permissions)
      .map((permissionResults: boolean[]): [MenuItem, boolean[]] => {
        return [menuItem, permissionResults];
      });
    })
    .map(([menuItem, permissionResults]): [MenuItem, boolean] => {
      let permissionMatch = menuItem.permissionMatch || 'all';
      if (permissionMatch === 'any') {
        return [menuItem, permissionResults.indexOf(true) > -1];
      } else if (permissionMatch === 'all') {
        return [menuItem, permissionResults.indexOf(false) === -1];
      }
    })
    .subscribe(([menuItem, hasPermission]) => {
      if (hasPermission) {
        this.menuItems.push(menuItem);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/menu/menu.service.ts